export const TAGS_MANAGEMENT_FORM_MODES = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
}



// WEBPACK FOOTER //
// ./src/Containers/Settings/TagsManagement/const.js